import {EVerificationStatus} from 'src/containers/Channels/Verification/definitions';

export default {
  company: 'Company',
  filters: {
    status: 'Request status',
    manager: 'Responsible manager',
    searchPlaceholder: 'quick search by Business Portfolio ID',
    period: 'Select period',
  },
  status: {
    [EVerificationStatus.DRAFT]: 'Draft',
    [EVerificationStatus.MANAGER_REVIEW]: 'Requires review',
    [EVerificationStatus.NEEDS_CORRECTION]: 'Requires revision',
    [EVerificationStatus.PENDING]: 'Under verification by Facebook',
    [EVerificationStatus.APPROVED]: 'Verification approved',
    [EVerificationStatus.REJECTED]: 'Verification rejected',
    [EVerificationStatus.REJECTED_PERMANENTLY]: 'Verification not available in the dashboard',
  },
  view: 'View',
  check: 'Review',
  send: 'Submit for verification',
  return: 'Return for revision',
  checkBanner: {
    title: 'How to review a verification request:',
    steps: [
      'Make sure that the documents, website, and business portfolio contain accurate company information (legal name, address, phone number).',
      'Confirm that the client’s business activity complies with WhatsApp policies. Only eligible businesses can be verified.',
      'If you find any issues or inconsistencies, contact the client and provide clear recommendations on how to improve the request or the documents.',
    ],
  },
};
